<template>
  <div class="appBody bg-grey-light">
    <div v-if="!loading">
<!--      <div class="shareImg position-fixed cursor-pointer">-->
<!--        <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--      </div>-->
      <little-header></little-header>
      <div v-if="sessionSignIn && sessionSignIn.id">
        <div v-if="signInFinished">
          <!--      <div v-if="updatingLearnInfo">正在更新学习记录</div>-->
          <signin-finished :sessionSignInObj="sessionSignIn"></signin-finished>
        </div>
        <div v-else>
          <div class="" v-if="sessionSignIn.signInSurvey">
            <div class="survey-summary"
                 v-if="sessionSignIn.summary">
              <p class=" mb-0 text-white font-11 line-22">
                {{sessionSignIn.summary}}
              </p>
            </div>
            <div v-if="showBtns">
              <div v-if="isShow" class="stroy-open  justify-content-center align-items-center font-14"
                   @click="open">
                <img class="mr-2 shou" src="/static/img/pro/kai1.png" alt="">展开
              </div>
              <div v-if="!isShow" class=" stroy-close  justify-content-center align-items-center font-14"
                   @click="close">
                <img class="mr-2 shou" src="/static/img/pro/shou1.png" alt="">收起
              </div>
            </div>


            <!-- 答题列表 -->
            <div v-if="surveyItemList">
              <div class="question-list"
                   v-for="item in surveyItemList" :key="item.id">
                <div class="question-card bg-white"
                     v-if="item.type !== 'section'">
                  <div class="d-flex align-items-center font-14 color-33 mb-2">
                    <div class="bg-base hao text-white">{{item.indexShow|numberFormat}}</div>
                    {{item.title}}（{{getTypeTxt(item.type)}}）
                  </div>
                  <div class="font-12 color-33">
                    <label v-if="item.type==='single' || item.type==='multiple'||item.type==='trueOrFalse'"
                           class="w-100 option mb-0"
                           v-for="opt in item.options" :key="opt.id" :id="opt.id">
                      <input v-if="item.type==='single'||item.type==='trueOrFalse'" type="radio"
                             @change="changeOpt(item, opt, $event)"
                             :name="item.title+item.type" v-model="allOption[item.id]" :value="opt.id">
                      <input v-if="item.type==='multiple'" type="checkbox"
                             @change="changeOpt(item, opt, $event)"
                             :name="item.title" v-model="allOption[item.id]" :value="opt.id">
                      {{opt.title}}
                    </label>
                    <van-field class="border mt-3 rounded-lg" v-if="item.type==='opening'"
                               v-model="allOption[item.id]"
                               @blur="changeOpt(item, allOption[item.id], $event)"
                               rows="3"
                               autosize
                               type="textarea"
                    />
                  </div>
                </div>
                <div class="bg-transparent font-11 color-33" v-else-if="item.type === 'section'">
                  {{item.title}}
                </div>
              </div>
            </div>
            <div class="signin-location m-3 text-truncate"
                 v-if="sessionSignIn.signInLocation">
              <van-row type="flex"
                       class=" py-20 bg-white align-items-center flex-nowrap text-truncate px-3 color-88 font-10 line-12">
                <van-col class="icon-map">
                  <van-icon class="icon-map" name="location"/>
                </van-col>
                <van-col class="text-primary font-10">
                  签到地点：
                </van-col>
                <van-col class="color-88 font-10 w-75  text-truncate">
                  {{currentAddress}}
                </van-col>
              </van-row>
            </div>
          </div>
          <div v-else class="signin-div pt-3 position-relative">
            <div class="signin-bg">
              <van-row type="flex" class="signin-content flex-column align-items-center">
                <van-col class="ava">
                  <van-image
                    round
                    :src="userInfo.avatar|getAvator"
                  />
                </van-col>
                <van-col class="name mt-28">{{userInfo.name}}</van-col>
                <van-col class="mt-28">
                  <van-row type="flex" class="flex-column align-items-center">
                    <van-col class="color-55 font-13 line-14">
                      现在是<span class="text-primary">{{new Date().getTime()|dateFormat('YYYY年MM月DD日 HH:mm')}}</span>
                    </van-col>
                    <van-col class="color-55 font-13 line-14 my-2">
                      本次活动已有<span class="text-primary">{{learnedCount}}位</span>参与者签到
                    </van-col>
                    <van-col class="color-55 font-13 line-14">
                      点击按钮，立即签到
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <div class="position-absolute signin-location  text-truncate max-w-80"
                   v-if="sessionSignIn.signInLocation">
                <van-row type="flex"
                         class="w-100 h-100 align-items-center flex-nowrap text-truncate px-3 color-88 font-10 line-12">
                  <van-col class="icon-map">
                    <van-icon class="icon-map" name="location"/>
                  </van-col>
                  <van-col class="text-primary font-10">
                    签到地点：
                  </van-col>
                  <van-col class="color-88 font-10 w-75  text-truncate">
                    {{currentAddress}}
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
          <van-button @click="signInFinish" class="signin-btn p-0 font-13" round type="info">立即签到</van-button>
        </div>
      </div>
      <no-data v-else text="当前签到页面不存在"></no-data>
      <little-footer :class="{'fixed-bottom max-w-640 m-auto': signInFinished}"></little-footer>
    </div>
    <van-loading class="py-5" v-else size="24px" vertical>加载签到信息</van-loading>
  </div>
</template>

<script>
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import SigninFinished from "./signinFinished";
  import NoData from "@/components/noData";
  import {mapState} from "vuex";
  import Vue from 'vue';
  import {Icon, Loading, SwipeCell, Button, Col, Row, Card, Progress, Image as VanImage, Field, Toast} from 'vant';
  import Cookies from "js-cookie";
  Vue.use(VanImage);
  Vue.use(Loading);
  Vue.use(Card);
  Vue.use(Progress);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(SwipeCell);
  Vue.use(Icon);
  Vue.use(Field);

  export default {
    name: "signinSession",
    data() {
      return {
        sid: '',
        loading: false,
        sessionSignIn: {},
        signInFinished: false,
        learnedCount: 0,
        currentAddress: '',
        // updatingLearnInfo: false,
        userInfo: {},
        GPS: {},
        indexShow: 0,
        surveyItemList: [],
        userSurveyItems: [],
        allOption: [],
        userSessionSignIn: {},
        bdRs: {},
        contentHeight: 0,
        isShow: false,
        uInfo: Cookies.get('u_info') ? JSON.parse(Cookies.get('u_info')) : {},
        showBtns: false
      }
    },
    components: {
      littleFooter,
      LittleHeader,
      SigninFinished,
      NoData
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        recordStudyTip: state => state.recordStudy
      })

    },
    created() {
    },
    mounted() {
      this.sid = this.$route.params['id'];
      this.getSessionSignInForLearner();
      this.contentHeight = $('body').css('lineHeight').substring(0, $('body').css('lineHeight').length-2)*2.75;
      this.$nextTick(() => {
        setTimeout(() => {
          let el = $('.survey-summary');
          if (el) {
            let summaryHeight = el.find('p').height();
            if (summaryHeight > this.contentHeight) {
              el.css('height', this.contentHeight);
              this.isShow = true;
              this.showBtns = true;
            } else {
              // el.css('height', summaryHeight+24);
             this.showBtns = false;
            }
          }
        },1000);
      });
      this.GPS = {
        PI: 3.14159265358979324,
        x_pi: 3.14159265358979324 * 3000.0 / 180.0,
        delta: function (lat, lon) {
          // Krasovsky 1940
          //
          // a = 6378245.0, 1/f = 298.3
          // b = a * (1 - f)
          // ee = (a^2 - b^2) / a^2;
          var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
          var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
          var dLat = this.transformLat(lon - 105.0, lat - 35.0);
          var dLon = this.transformLon(lon - 105.0, lat - 35.0);
          var radLat = lat / 180.0 * this.PI;
          var magic = Math.sin(radLat);
          magic = 1 - ee * magic * magic;
          var sqrtMagic = Math.sqrt(magic);
          dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
          dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
          return {'lat': dLat, 'lon': dLon};
        },
        //GPS---高德---百度
        gcj_encrypt: function (wgsLat, wgsLon) {
          if (this.outOfChina(wgsLat, wgsLon))
            return {'lat': wgsLat, 'lon': wgsLon};

          var d = this.delta(wgsLat, wgsLon);
          return {'lat': wgsLat + d.lat, 'lon': wgsLon + d.lon};
        },
        gcj_baidu: function (lng, lat) {
          if (debug) {
            document.querySelector('#log_div').innerHTML += '<br>gcj_baidu ：lng= ' + lng + ', lat= ' + lat;
          }
          //高德
          let gdXy = this.gcj_encrypt(lat, lng);
          if (debug) {
            document.querySelector('#log_div').innerHTML += '<br>gdXy ：输出对象 ：';
            document.querySelector('#log_div').innerHTML += '<br>' + JSON.stringify(gdXy);
          }
          let _lng = gdXy.lon;
          let _lat = gdXy.lat;
          var z = Math.sqrt(_lng * _lng + _lat * _lat) + 0.00002 * Math.sin(_lat * this.x_pi);
          var theta = Math.atan2(_lat, _lng) + 0.000003 * Math.cos(_lng * this.x_pi);
          var bd_lng = z * Math.cos(theta) + 0.0065;
          var bd_lat = z * Math.sin(theta) + 0.006;
          if (debug) {
            document.querySelector('#log_div').innerHTML += '<br>bd_lng= ' + bd_lng;
            document.querySelector('#log_div').innerHTML += '<br>bd_lat= ' + bd_lat;
          }
          return {'lat': bd_lat, 'lon': bd_lng};
        },
        outOfChina: function (lat, lon) {
          if (lon < 72.004 || lon > 137.8347)
            return true;
          if (lat < 0.8293 || lat > 55.8271)
            return true;
          return false;
        },
        transformLat: function (x, y) {
          var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
          ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
          ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
          return ret;
        },
        transformLon: function (x, y) {
          var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
          ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
          ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
          return ret;
        }
      };
      if (Cookies.get('anqiu_education_token') && Cookies.get('u_info')) {
        this.userInfo = JSON.parse(Cookies.get('u_info'));
      } else {
        this.userInfo = {};
      }
    },

    methods: {
      open() {
        $('.survey-summary').css('height', 'auto');
        this.isShow = false;
      },
      close() {
        $('.survey-summary').css('height',this.contentHeight);
        this.isShow = true;
      },
      getSessionSignInForLearner() {
        this.loading = true;
        this.$store.dispatch('getSessionSignInForLearnerUrl', {id: this.sid}).then((res) => {
          this.loading = false;
          if (res) {
            this.sessionSignIn = res;
            //判断是否已签到
            if (res.userSession && res.userSession.finished) {
              this.signInFinished = true;
            } else {
              this.signInFinished = false;
            }
            if (this.sessionSignIn.statInfo && this.sessionSignIn.statInfo['learnedCount']) {
              this.learnedCount = parseInt(this.sessionSignIn.statInfo['learnedCount']);
            }
            //判断签到信息  是否设置签到地点
            // if (!this.sessionSignIn.signInLocation) {
            //   this.getCurrentPosition();
            // }
            //改成所有签到都要提交签到经纬度
            this.getCurrentPosition();

            //整理答题部分的显示数据
            if (this.sessionSignIn.signInSurvey && this.sessionSignIn.surveyItems && this.sessionSignIn.surveyItems.length > 0) {
              for (let item of this.sessionSignIn.surveyItems) {
                if (item.options && item.options.length > 0) {
                  for (let j = 0; j < item.options.length; j++) {
                    item.options[j].index = j;
                  }
                }
                if (item.type !== 'section') {
                  this.indexShow++;
                  item.indexShow = this.indexShow;
                }
                this.surveyItemList.push(item);
              }
            }
          }
        })
      },
      getTypeTxt(type) {
        switch (type) {
          case 'single':
            return '单选';
          case 'multiple':
            return '多选';
          case 'trueOrFalse':
            return '判断';
          case 'opening':
            return '主观';
          default:
            return '';
        }
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.sessionSignIn;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
      // ///获取定位
      getCurrentPosition() {
        if (navigator && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((p) => {
            if (p && p.coords) {
              //初始经纬度
              let x = p.coords.longitude;
              let y = p.coords.latitude;
              // 转换成高德经纬度
              let transXY = this.GPS.gcj_baidu(x, y);
              let _lng = transXY.lon;//转换后的
              let _lat = transXY.lat;
              this.bdRs.lng = _lng;
              this.bdRs.lat = _lat;
              //保存用户签到经纬度
              let map = new BMap.Map("allmap");
              let point = new BMap.Point(_lng, _lat);
              var geoc = new BMap.Geocoder();  //地址解析对象
              geoc.getLocation(point, function (rs) {
                let addComp = rs.addressComponents;
                this.currentAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                alert(addComp);
              });

            } else {
              console.log('无法获取您的位置，请允许应用获取您的定位信息！');
            }
          }, (error) => {
            if (error && error.code === error.TIMEOUT) {
              console.log('请求地理位置超时，请检查网络！');
            } else {
              console.log('无法获取您的位置，请允许应用获取您的定位信息');
            }

          }, {enableHighAccuracy: true, timeout: 5000, maximumAge: 0});
        } else {//不支持浏览器定位
          console.log('请允许应用获取您的定位信息！');
        }
      },
      changeOpt(question, opt, event) {
        let status = event.target.checked;
        //初始化
        if (question.type === 'opening') {
          this.allOption[question.id] = '';
          this.allOption[question.id] = opt;
        } else {
          this.optContent = (this.allOption[question.id] && this.allOption[question.id].length > 0) ? this.allOption[question.id] : [];
          if (status) { //选中
            if (this.optContent.indexOf(opt.id) < 0) {
              this.optContent.push(opt.id)
            }
          } else {
            this.optContent = this.optContent.filter(v => v !== opt.id);
          }
          this.allOption[question.id] = this.optContent;
        }
      },
      //签到方法
      signInFinish() {
        if(!this.sessionSignIn.recordStudy) {
          this.$toast(this.recordStudyTip);
          return;
        }
        //判断是否有答卷 且答完题目
        if (this.sessionSignIn.signInSurvey) {
          if (this.surveyItemList && this.surveyItemList.length > 0) {
            for (let svm of this.surveyItemList) {
              let model = {};
              if (svm.type === 'section') {
                continue;
              }
              if (!this.allOption[svm.id]) {
                this.$toast('请完善信息后再签到!');
                return;
              } else {
                model.answers = (svm.type === 'single' || svm.type === 'trueOrFalse'||svm.type === 'opening') ? [this.allOption[svm.id]] :this.allOption[svm.id];
              }
              model.userId = this.uInfo.id;
              model.surveyId = svm.surveyId;
              model.surveyItemId = svm.id;
              model.sort = svm.sort;
              this.userSurveyItems.push(model);
            }
          }
        }
        // 经度、纬度
        //  this.userSessionSignIn.signInLocation = '[117.05732649170987,36.68444630272359]';
        if(!this.bdRs.lng && !this.bdRs.lat) {
          this.userSessionSignIn.signInLocation = '[0.0,0.0]';
        }else {
          this.userSessionSignIn.signInLocation = '[' + this.bdRs.lng + ',' + this.bdRs.lat + ']';
        }
        this.userSessionSignIn.userSurveyItems = this.userSurveyItems;

        //提交签到信息
        this.$store.dispatch('updateSessionSignInFinishedUrl', {
          id: this.sessionSignIn.id,
          userSessionSignIn: this.userSessionSignIn
        }).then((res) => {
          if (res) {
            this.signInFinished = true;
            // location.reload();
          }
        },(error) => {
          if(error) {
            if (error.response.data.errorType === 'UserProjectNotInStartTimeException') {
              this.$toast(this.recordStudyTip);
            }else {
              this.$toast(error.response.data.consumerMessage);
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }
  .max-w-80 {
    max-width: 80%;
  }

  .mt-28 {
    margin-top: pxTorem(28px);
  }

  .signin-div {
    background-color: white;
    margin: pxTorem(28px) pxTorem(16px) pxTorem(0px) pxTorem(16px);
    height: pxTorem(392px);
    border-radius: pxTorem(4px);
  }

  .survey-div {
    margin: pxTorem(28px) pxTorem(16px) pxTorem(0px) pxTorem(16px);
  }

  .signin-bg {
    height: pxTorem(178px);
    background: url("/static/img/pro/sigin_bg.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    .name {
      font-size: pxTorem(14px);
      line-height: pxTorem(16px);
      color: #333333;
    }
    .ava {
      margin-top: pxTorem(50px);
      width: pxTorem(60px);
      height: pxTorem(60px);
      border-radius: 50%;
    }
    .signin-location {
      left: pxTorem(16px);
      bottom: pxTorem(20px);
      height: pxTorem(20px);
      background-color: #eeeeee;
      border-radius: pxTorem(10px);
    }
  }

  .signin-btn {
    margin: pxTorem(32px) pxTorem(44px) pxTorem(0px) pxTorem(44px);
    height: pxTorem(36px);
    width: pxTorem(260px);
  }

  .icon-map {
    width: pxTorem(12px);
    height: pxTorem(12px);
    margin-right: pxTorem(4px);
    color: #2474ff;
  }

  .question-list {
    margin: pxTorem(26px) pxTorem(20px) pxTorem(0px) pxTorem(20px);
  }

  .question-card {
    background-color: white;
    min-height: pxTorem(100px);
    box-shadow: 1px 1px 0 1px #9999991c;
    border-radius: .25rem;
    padding: pxTorem(16px) pxTorem(16px) pxTorem(24px) pxTorem(22px);
  }

  .change-btn {
    height: 1rem;
  }

  .van-nav-bar .van-icon {
    color: #333333;
    font-size: 2rem;
  }

  .van-nav-bar__title {
    font-size: 1.5rem;
  }


  .van-nav-bar__right {
    margin-top: .125rem;
  }

  .hao {
    border-radius: pxTorem(8px);
    width: pxTorem(27px);
    height: pxTorem(27px);
    margin-right: pxTorem(14px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .xuhao {
    max-width: 640px;
    margin: 0 auto;
  }

  .van-radio__label {
    margin-left: 16px;
  }

  .option {
    display: flex;
    align-items: center;
    width: 100%;
    height: pxTorem(40px);
    border-radius: .75rem;
    cursor: pointer;
  }

  .option input {
    margin-right: 1.5rem;
    width: 1rem;
    height: 1rem;
    flex: none;
    cursor: pointer;
  }

  .survey-summary {
    padding: pxTorem(8px) pxTorem(24px) pxTorem(8px) pxTorem(24px);
    background-color: #4d77c3;
    height: pxTorem(72px);
    overflow: hidden;
  }
  .stroy-open, .stroy-close {
    cursor: pointer;
    display: flex;
    background-color: #4d77c3;
    color: white;
    padding-top: .5rem;
  }
</style>
